import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import Menubar from "../Components/Menubar";
import Totop from "../Components/Totop";
import Footer from "../Components/Footer";

import "./Contactus.css";
import { ThemeContext, MediaQueryContext } from "../../context";

const renderMultiline = (text) =>
  text.split("\n").map((line, i, arr) => (
    <React.Fragment key={i}>
      {line}
      {i < arr.length - 1 && <br />}
    </React.Fragment>
  ));

export default function ContactUs(props) {
  const { t } = useTranslation();
  const [cName, setCName] = useState("");
  const [cEmail, setCEmail] = useState("");
  const [cPhone, setCPhone] = useState("");
  const [cMessage, setCMessage] = useState("");

  const renderSubmitBtn = () => {
    return (
      <div className="contactSquareButton">
        <span
          className="ContactButtonLink FontB"
          style={{ fontSize: "clamp(0.9rem, 1.044vw, 1.2rem)" }}
          onClick={(e) => submitData(e)}
        >
          {t("contactus.form.submit")}
        </span>
      </div>
    );
  };

  const onChange = (e) => {
    switch (e.target.name) {
      case "cName":
        setCName(e.target.value);
        break;
      case "cEmail":
        setCEmail(e.target.value);
        break;
      case "cPhone":
        setCPhone(e.target.value);
        break;
      case "cMessage":
        setCMessage(e.target.value);
        break;
      default:
        break;
    }
  };

  const submitData = (e) => {
    e.preventDefault();
    if (!cName && !cEmail && !cPhone && !cMessage) {
      alert(t("contactus.alerts.empty"));
      return;
    }
    onSubmit(e);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    let resGetter = 0;
    var sendobj = {
      cName: cName,
      cEmail: cEmail,
      cPhone: cPhone,
      cMessage: cMessage,
    };

    fetch("/api/contactus", {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify(sendobj),
    })
      .then((response) => response.json())
      .then((result) => {
        resGetter = result;
        if (resGetter) {
          alert(t("contactus.alerts.success"));
          window.location.reload();
        } else {
          alert(t("contactus.alerts.error"));
        }
      });
  };

  const { theme } = useContext(ThemeContext);
  const { mTablet } = useContext(MediaQueryContext);
  const scrollElem = Array.from(Array(2).keys());
  const refs = useRef(scrollElem.map(() => React.createRef()));

  const executeScroll = () => {
    const element = document.getElementById(props.location.hashId);
    const headOffset = mTablet ? 84 : 184;
    const elementPosition = element?.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - headOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    executeScroll();
  }, [props.location.update]);

  return (
    <div
      id="contactus"
      style={{
        backgroundColor: theme === "dark" && "#282828",
        color: theme === "dark" && "#fff",
      }}
    >
      <Menubar slideIndex={0} />

      <div id="contact">
        <div className="contact_container">
          <div className="contact_section1">
            <div className="contact_text_section1">
              <p className="ir_maintext1">
                {renderMultiline(t("contactus.hero.title"))}
              </p>
              <span className="ir_subtext1">{t("contactus.hero.subtitle")}</span>
            </div>
          </div>
          <div className="contact_section2">
            <div className="contactusContentsDiv">
              <div className="contactusInputDiv">
                <p className="card_titleLeft">{t("contactus.form.contactTitle")}</p>
                <form
                  method="POST"
                  className="contactusInputForm "
                  id="contactDatas"
                >
                  <div className="contactusInputNamePhoneLayout">
                    <input
                      type="text"
                      onChange={onChange}
                      placeholder={t("contactus.form.name")}
                      name="cName"
                      className="FontR textF16 contactusInputNamePhone"
                    />
                    <input
                      type="text"
                      onChange={onChange}
                      placeholder={t("contactus.form.phone")}
                      name="cPhone"
                      className="FontR textF16 contactusInputNamePhone"
                    />
                  </div>
                  <input
                    type="text"
                    onChange={onChange}
                    placeholder={t("contactus.form.email")}
                    name="cEmail"
                    className="FontR textF16"
                  />

                  <textarea
                    type="textarea"
                    placeholder={t("contactus.form.message")}
                    onChange={onChange}
                    style={{
                      height: "123px",
                      resize: "none",
                      overflow: "auto",
                    }}
                    name="cMessage"
                    className="FontR textF16"
                  />
                  <div className="contactSquareButtonContain">
                    {renderSubmitBtn()}
                  </div>
                </form>
              </div>
              <div className="contractusMapWrap">
                <p className="card_titleLeft">{t("contactus.form.officeTitle")}</p>

                <div className="contractusMap">
                  <iframe
                    title="maps"
                    className="maps"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3164.5!2d126.9249!3d37.5255!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c9f1a8e2b9b9f%3A0x0!2z7ISc7Jq47Yq567OE7IucIOyYgeuTsO2PrOq1rCDqta3soJzquIjsnLXroZwgMjAg7Jyo7LSM67mM65Sp!5e0!3m2!1sko!2skr!4v1570788489588!5m2!1sko!2skr"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                </div>
                <div style={{ paddingTop: "2.5vw" }}>
                  {/* 사업자등록증상 법인명 */}
                  <p className="contact_company">{t("contactus.form.company")}</p>
                  <span className="ir_subtext1" style={{ color: "#000000" }}>
                    {renderMultiline(t("contactus.form.address"))}
                  </span>
                  <p className="contact_sub_text">
                    <span style={{ color: "#f68c29" }}>{t("contactus.form.emailLabel")}</span>{" "}
                    {t("contactus.form.emailValue")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Totop />
      <Footer />
    </div>
  );
}
